import { Link } from 'react-router-dom';
import { AlertTriangle, ExternalLink } from 'lucide-react';
import { Card } from '@/components/ui/Card';

/**
 * Shown when the app boots but Firebase web SDK env vars are missing or invalid.
 * This is a pre-auth screen — the user doesn't need to sign in to see it.
 */
export default function ConfigRequired() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-canvas p-6">
      <Card className="max-w-xl w-full p-8">
        <div className="flex items-start gap-4">
          <div className="w-10 h-10 rounded-full bg-warning/10 flex items-center justify-center text-warning flex-shrink-0">
            <AlertTriangle size={20} />
          </div>
          <div>
            <h1 className="text-section font-display font-semibold text-ink">
              Firebase configuration required
            </h1>
            <p className="text-body text-ink-subtle mt-2">
              App ini butuh <strong>Firebase Web SDK config</strong> di file <code>.env</code>
              {' '}sebelum bisa jalan. Config-nya bisa diambil dari Firebase Console.
            </p>

            <div className="mt-6 p-4 rounded bg-canvas border border-line">
              <p className="text-small font-medium text-ink mb-2">Steps:</p>
              <ol className="text-small text-ink-subtle space-y-1.5 list-decimal pl-4">
                <li>
                  Buka{' '}
                  <a
                    href="https://console.firebase.google.com/project/dev-universal-project/settings/general"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-primary hover:underline inline-flex items-center gap-1"
                  >
                    Firebase Console
                    <ExternalLink size={12} />
                  </a>
                </li>
                <li>Pilih project <code>dev-universal-project</code></li>
                <li>
                  Buka <strong>Project Settings → General → Your apps → Web app</strong>
                </li>
                <li>Copy <strong>SDK setup &amp; configuration</strong> values</li>
                <li>
                  Buat file <code>.env</code> di root project, isi dengan:
                </li>
              </ol>
              <pre className="mt-3 p-3 rounded bg-surface border border-line text-caption text-ink font-mono overflow-x-auto">
{`VITE_FIREBASE_API_KEY=AIza...
VITE_FIREBASE_AUTH_DOMAIN=dev-universal-project.firebaseapp.com
VITE_FIREBASE_PROJECT_ID=dev-universal-project
VITE_FIREBASE_STORAGE_BUCKET=dev-universal-project.appspot.com
VITE_FIREBASE_MESSAGING_SENDER_ID=123456789
VITE_FIREBASE_APP_ID=1:123:web:abc`}
              </pre>
            </div>

            <p className="text-caption text-ink-subtle mt-4">
              File <code>.env.example</code> di root project adalah template.
              Lihat <Link to="/login" className="text-primary hover:underline">login</Link>
              {' '}setelah env sudah di-set.
            </p>
          </div>
        </div>
      </Card>
    </div>
  );
}
